import lotsBasicDataSelector from './index.vue';

lotsBasicDataSelector.install = (Vue) => {
    Vue.component(lotsBasicDataSelector.name, lotsBasicDataSelector);
};
export default lotsBasicDataSelector;
